// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "table tr td[data-v-0ece6e17]:nth-child(1) {\n  width: 20%;\n  text-align: right;\n}\ntable tr td[data-v-0ece6e17]:nth-child(2) {\n  width: 80%;\n}", ""]);
// Exports
module.exports = exports;
